var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_764_2",
    "data-name": "Component 764 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16418",
    "data-name": "Rectangle 16418",
    width: 25,
    height: 25,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "polygon-fill-svgrepo-com",
    d: "M29.959,19.309a3.159,3.159,0,0,0-4.462,0h0a3.14,3.14,0,0,0-.508.666l-2.782-.759a3.154,3.154,0,0,0-5.382-2.273h0a3.159,3.159,0,0,0-.567,3.688L12.91,23.642a3.16,3.16,0,0,0-3.974.394h0a3.154,3.154,0,0,0,4.227,4.673l6.9,5.063a3.154,3.154,0,1,0,5.16-1.061,3.106,3.106,0,0,0-.471-.386l2.7-7.649q.136.012.272.012A3.154,3.154,0,0,0,29.955,19.3Zm-6.69,12.5A3.148,3.148,0,0,0,21,32.5l-6.9-5.063a3.167,3.167,0,0,0-.131-2.627L17.315,21.8A3.154,3.154,0,0,0,21.8,20.738l2.777.759a3.142,3.142,0,0,0,1.391,2.662Z",
    transform: "translate(-7.014 -14.421)",
    fill: "#102633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoiIcon);
export default __webpack_public_path__ + "static/media/roiIcon.1a7386eee2292da1d1f5723136b209c8.svg";
export { ForwardRef as ReactComponent };